<!--TODO Can And Should be simplified as to have a single label field rendered and then perform ui logic from CSS -->
<label *ngIf="leftLabel"
       [for]="id">
    {{ label }}
    <app-tooltip *ngIf="tooltipText" record="{{tooltipText}}"></app-tooltip>
</label>
<div class="input-field"
     [class.ui-float-label]="floatLabel"
     [class.invalid]="hasError">
    <label *ngIf="topLabel" [for]="id" class="active">
        {{ label }}
        <app-tooltip *ngIf="tooltipText" record="{{tooltipText}}"></app-tooltip>
    </label>

    <ng-container [ngSwitch]="type">
        <!-- Text Input -->
        <input *ngSwitchCase="'text'"
               [id]="id"
               [(ngModel)]="value"
               [disabled]="isDisabled"
               [readonly]="isReadonly"
               [placeholder]="determinePlaceholder"
               (blur)="onBlur()"
               type="text"
               pInputText>

        <!-- Password Input -->
        <input *ngSwitchCase="'password'"
               [id]="id"
               [(ngModel)]="value"
               [disabled]="isDisabled"
               [readonly]="isReadonly"
               [placeholder]="determinePlaceholder"
               (blur)="onBlur()"
               type="password"
               pInputText>

        <!-- Number Input -->
        <input *ngSwitchCase="'number'"
               [id]="id"
               [(ngModel)]="value"
               [disabled]="isDisabled"
               [readonly]="isReadonly"
               [placeholder]="determinePlaceholder"
               (blur)="onBlur()"
               [allowNegativeNumbers]="allowNegative"
               [maxlength]="maxLength"
               [mask]="mask"
               [thousandSeparator]="thousandSeparator"
               decimalMarker="."
               type="text"
               pInputText>

        <input *ngSwitchDefault
               [id]="id"
               [(ngModel)]="value"
               [disabled]="isDisabled"
               [readonly]="isReadonly"
               [placeholder]="determinePlaceholder"
               (blur)="onBlur()"
               type="text"
               pInputText>
    </ng-container>

    <label *ngIf="floatLabel" [for]="id" class="active">{{ label }}</label>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl?.errors"></app-form-error-list>
</div>

